import React from 'react';
import { Form, Input } from 'antd';
import { EyeInvisibleOutlined, EyeOutlined, LockOutlined } from '@ant-design/icons';
import { Control, Controller } from 'react-hook-form';

export interface PasswordFormValues {
  password: string;
}

interface PasswordFormProps {
  control: Control<PasswordFormValues>;
  onSubmit: () => void;
}

const PasswordForm: React.FC<PasswordFormProps> = ({ control, onSubmit }) => {
  return (
    <>
      <Form layout="vertical" onFinish={onSubmit}>
        <Controller
          control={control}
          name="password"
          rules={{
            required: 'Please input your password',
          }}
          render={({ field, fieldState }) => (
            <Form.Item validateStatus={fieldState.error && 'error'} help={fieldState.error?.message}>
              <Input.Password
                size="large"
                className="border-content-secondary shadow-none"
                prefix={<LockOutlined className="text-content-secondary mr-1" />}
                iconRender={(visible) => {
                  // div is necessary to escape default style.
                  return (
                    <div>
                      {visible ? (
                        <EyeInvisibleOutlined className="text-content-secondary" />
                      ) : (
                        <EyeOutlined className="text-content-secondary" />
                      )}
                    </div>
                  );
                }}
                placeholder="Password"
                {...field}
              />
            </Form.Item>
          )}
        />
      </Form>
    </>
  );
};

export default PasswordForm;
